// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2M1fj","content":"styles_content__xISD0","selectAll":"styles_selectAll__2mdR5"};